if (!customElements.get('halloween-countdown')) {
  customElements.define('halloween-countdown', class extends HTMLElement {
    static get observedAttributes() {
      return ['data-end', 'data-expiry', 'data-placeholder'];
    }

    connectedCallback() {
      if (this.events) return;
      this.panel = this.querySelector('[data-countdown-panel]');
      if (!this.panel) return;
      this.fields = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(unit => [
        unit, this.querySelector(`[data-${unit}]`)
      ]));
      this.events = new AbortController();
      document.addEventListener('visibilitychange', () => this.updateCountdown(), {
        signal: this.events.signal
      });
      this.updateCountdown();
    }

    attributeChangedCallback() {
      if (this.events) this.updateCountdown();
    }

    renderValues(values) {
      Object.entries(values).forEach(([unit, value]) => {
        if (this.fields[unit]) this.fields[unit].textContent = String(value).padStart(2, '0');
      });
    }

    updateCountdown() {
      window.clearTimeout(this.countdownTimeout);
      if (!this.isConnected || !this.panel) return;

      const rawEnd = this.dataset.end?.trim() || '';
      if (!rawEnd) {
        const placeholder = Boolean(window.Shopify?.designMode) || this.dataset.placeholder === 'true';
        this.dataset.countdownState = placeholder ? 'placeholder' : 'unset';
        this.panel.hidden = !placeholder;
        if (placeholder) this.renderValues({ days: 2, hours: 14, minutes: 36, seconds: 28 });
        return;
      }

      const end = Date.parse(rawEnd);
      if (!Number.isFinite(end)) {
        this.dataset.countdownState = 'invalid';
        this.panel.hidden = true;
        return;
      }

      const remaining = Math.max(0, end - Date.now());
      const expired = remaining === 0;
      this.dataset.countdownState = expired ? 'expired' : 'running';
      this.panel.hidden = expired && this.dataset.expiry === 'hide';
      this.renderValues({
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining % 86400000) / 3600000),
        minutes: Math.floor((remaining % 3600000) / 60000),
        seconds: Math.floor((remaining % 60000) / 1000)
      });

      if (!expired && !document.hidden) {
        this.countdownTimeout = window.setTimeout(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.countdownTimeout);
      this.events?.abort();
      this.events = null;
    }
  });
}
